import { sendPost } from '../http.js'
const api = {
	'ksAuthorize': '/user/ks/authorize',
    'ksIsApply': '/user/ks/isApply'
}
export default {
	ksAuthorize(params) {
	    return sendPost(api.ksAuthorize, params)
	},
    ksIsApply(params) {
        return sendPost(api.ksIsApply, params)
    }
}